/**
 * C.11 — Route decision for NIPE chat.
 *
 *   byok-direct   → SPA calls OpenRouter with the user's key.
 *   convex-backup → SPA calls the Convex `nipeChat.chat` action which
 *                   uses the firm key.
 *
 * Demo users (no Clerk identity) always route through Convex backup;
 * signed-in users without an OpenRouter key in Settings also route
 * through backup; signed-in users WITH a key go BYOK-direct.
 *
 * Rule per `feedback_paired_audit_tables` + handoff doc: the Convex
 * action must NEVER double-bill — if the user has a key AND is not in
 * demo mode, the backup path must not be taken.
 */

export type NipeRoute = 'byok-direct' | 'convex-backup';

export interface RouteInputs {
  /** True when the user is in an anonymous demo session. */
  demoMode: boolean;
  /** Trimmed OpenRouter API key from Settings, or null/empty if absent. */
  userOpenRouterKey: string | null | undefined;
}

export function chooseRoute(input: RouteInputs): NipeRoute {
  if (input.demoMode) return 'convex-backup';
  if (!input.userOpenRouterKey || input.userOpenRouterKey.length === 0) {
    return 'convex-backup';
  }
  return 'byok-direct';
}

/**
 * Mask an OpenRouter key for display. Never render the raw key; this
 * function is the single source of truth for the redacted form.
 */
export function maskKey(key: string | null | undefined): string {
  if (!key || key.length === 0) return '';
  const tail = key.slice(-4);
  return `••••${tail}`;
}
